export const imageBase = "/images/motiona-v2";
export const siteUrl = "https://motiona.kr";
export const siteImage = "/opengraph-image.png";

export const ctaLinks = {
  naverBooking:
    "https://m.booking.naver.com/booking/13/bizes/1632704/items/7586427?area=pll&entry=pll&lang=ko&startDate=2026-06-10&tab=book&theme=place",
  centerSms:
    "sms:01082758875?body=%EC%84%BC%ED%84%B0%20%EC%9E%AC%ED%99%9C%EC%9A%B4%EB%8F%99%20%EC%83%81%EB%8B%B4%20%EB%AC%B8%EC%9D%98%EB%93%9C%EB%A6%BD%EB%8B%88%EB%8B%A4.%0A%0A%EB%8C%80%EC%83%81%EC%9E%90%20%EC%97%B0%EB%A0%B9%3A%0A%EB%B6%88%ED%8E%B8%ED%95%9C%20%EB%B6%80%EC%9C%84%20%EB%98%90%EB%8A%94%20%EC%9E%AC%ED%99%9C%20%EB%AA%A9%EC%A0%81%3A%0A%EC%A7%84%EB%8B%A8%EB%AA%85%20%EB%B0%8F%20%EC%A3%BC%EC%9A%94%20%EA%B8%B0%EC%A0%80%EC%A7%88%ED%99%98(%EC%84%A0%ED%83%9D)%3A%0A%ED%9D%AC%EB%A7%9D%20%EC%9A%94%EC%9D%BC%20%EB%B0%8F%20%EC%8B%9C%EA%B0%84%EB%8C%80%3A",
  visitSms:
    "sms:01082758875?body=%EB%B0%A9%EB%AC%B8%EC%9E%AC%ED%99%9C%20%EC%83%81%EB%8B%B4%20%EB%AC%B8%EC%9D%98%EB%93%9C%EB%A6%BD%EB%8B%88%EB%8B%A4.%0A%EC%A7%80%EC%97%AD%3A%0A%EB%8C%80%EC%83%81%EC%9E%90%20%EC%83%81%ED%83%9C%3A%0A%ED%9D%AC%EB%A7%9D%20%EC%8B%9C%EA%B0%84%3A",
  kakaoTalk: "http://qr.kakao.com/talk/1UG8dz93o7u5VUeT3Kp3HTuQjTE-",
  phone: "tel:02-907-8875",
  reviews:
    "https://m.booking.naver.com/booking/13/bizes/1632704/items/7586427?area=pll&entry=pll&lang=ko&startDate=2026-06-10&tab=review&theme=place",
  email: "mailto:motiona_js8875@naver.com",
};

export const contact = {
  mobile: "010-8275-8875",
  phone: "02-907-8875",
  email: "motiona_js8875@naver.com",
  address: "서울특별시 강북구 노해로 113 B1층 모티오나 재활운동센터",
  streetAddress: "노해로 113 B1층",
  locality: "강북구",
  region: "서울특별시",
  country: "KR",
};

export const businessProfile = {
  name: "MOTIONA 재활운동센터",
  koreanName: "모티오나 재활운동센터",
  slogan: "병원 이후 일상 회복을 이어가는 1:1 재활운동",
  description:
    "서울 강북구 수유동 재활운동센터로, 수유역 인근에서 병원 이후 일상 회복을 이어가는 예약제 1:1 재활운동센터입니다.",
  serviceArea: ["서울특별시 강북구 수유동", "서울특별시 강북구", "서울특별시", "경기북부"],
  services: [
    "센터 재활운동",
    "방문재활운동",
    "신경계 재활운동",
    "근골격계 재활운동",
    "수술 전후 회복 운동",
    "보행·균형 기능운동",
  ],
  keyTopics: [
    "수유동 재활운동센터",
    "병원 이후 재활운동",
    "강북구 재활운동센터",
    "수유역 재활운동",
    "방문재활운동",
    "신경계 기능회복 운동",
    "근골격계 통증·기능개선",
    "수술 전후 회복 운동",
    "보행·균형 기능운동",
    "1:1 재활운동",
  ],
  medicalDisclaimer:
    "MOTIONA는 의료기관이 아닌 기능회복 재활운동센터이며, 의료 진단이나 치료를 대신하지 않습니다.",
};

export const routeSeo = {
  home: {
    path: "/",
    title: "MOTIONA 재활운동센터 | 서울·경기북부 방문재활·재활운동센터",
    description:
      "서울 강북구 수유동 재활운동센터 MOTIONA입니다. 수유역 인근에서 병원 이후 일상 회복을 위해 센터 재활운동과 방문재활운동을 1:1로 안내합니다.",
    openGraphDescription:
      "서울 강북구 수유동 재활운동센터. 수유역 인근에서 자세, 보행, 균형, 체중지지를 확인하고 일상 회복을 위한 재활운동을 안내합니다.",
    keywords: [
      "수유동 재활운동센터",
      "MOTIONA 재활운동센터",
      "모티오나 재활운동센터",
      "강북구 재활운동센터",
      "수유역 재활운동",
      "방문재활운동",
      "병원 이후 재활운동",
      "보행 균형 재활운동",
    ],
    primaryImage: "/images/motiona-v2/main-hero.webp",
    changeFrequency: "weekly",
    priority: 1,
  },
  services: {
    path: "/services",
    title: "센터 소개 | MOTIONA 재활운동센터",
    description:
      "서울 강북구 수유동 MOTIONA 재활운동센터의 1:1 재활운동 흐름입니다. 현재 움직임을 평가하고 신경계·근골격계 재활운동, 수술 전후 회복, 방문재활 상담까지 안내합니다.",
    openGraphDescription:
      "수유동, 수유역 인근에서 현재 움직임을 평가하고 센터 재활운동, 방문재활운동, 상담 흐름까지 한 페이지에서 확인하세요.",
    keywords: [
      "수유동 재활운동센터",
      "강북구 재활운동센터",
      "수유역 재활운동센터",
      "신경계 재활운동",
      "근골격계 재활운동",
      "수술 후 재활운동",
      "방문재활 상담",
    ],
    primaryImage: "/images/motiona-v2/services-center-program-banner-v1.webp",
    changeFrequency: "weekly",
    priority: 0.9,
  },
  centerPhotos: {
    path: "/center-photos",
    title: "센터 사진 | MOTIONA 재활운동센터",
    description:
      "서울 강북구 MOTIONA 재활운동센터의 센터 공간, 평가 장면, 개인별 재활운동, 방문재활 자료 사진을 한 번에 확인하세요.",
    openGraphDescription:
      "센터 공간과 실제 1:1 재활운동 자료 사진을 모아 확인할 수 있는 MOTIONA 센터 사진 페이지입니다.",
    keywords: [
      "MOTIONA 센터 사진",
      "모티오나 센터 사진",
      "강북구 재활운동센터 사진",
      "1:1 재활운동 사진",
      "방문재활 자료 사진",
    ],
    primaryImage: "/images/motiona-center-photos/center-gallery-a.webp",
    changeFrequency: "monthly",
    priority: 0.7,
  },
} as const;

export const siteKeywords = Array.from(
  new Set([
    ...businessProfile.keyTopics,
    ...routeSeo.home.keywords,
    ...routeSeo.services.keywords,
    ...routeSeo.centerPhotos.keywords,
  ]),
);

export const navigation = [
  { href: "/", label: "HOME", shortLabel: "홈", key: "home" },
  {
    href: "/services",
    label: "센터 소개",
    shortLabel: "센터소개",
    key: "services",
  },
  {
    href: "/center-photos",
    label: "센터 사진",
    shortLabel: "센터사진",
    key: "centerPhotos",
  },
] as const;

export type NavKey = (typeof navigation)[number]["key"];

export type MotionaImage = {
  src: string;
  alt: string;
  caption: string;
};

export type ServiceHeroSlide = {
  title: string;
  image: MotionaImage;
  desktopPosition: string;
  mobilePosition: string;
};

export const images = {
  heroCenterSceneDesktop: {
    src: `${imageBase}/hero-representative-desktop-v2.webp`,
    alt: "따뜻한 미니멀 배경 오른쪽에 서 있는 MOTIONA 대표 프로필 히어로 이미지",
    caption: "PC 홈 첫 화면을 위한 4K 대표 프로필 기반 미니멀 히어로 이미지입니다.",
  },
  homeWonJyouHero: {
    src: `${imageBase}/main-hero.webp`,
    alt: "검은 배경 오른쪽에 MOTIONA 대표가 서 있고 왼쪽에는 큰 문구를 배치할 수 있는 HOME 히어로 이미지",
    caption: "WonJYou 스타일 HOME 히어로를 위해 제공된 MOTIONA 대표 이미지입니다.",
  },
  homeWonJyouHeroMobile: {
    src: `${imageBase}/mobile-hero.webp`,
    alt: "검은 배경 오른쪽에 MOTIONA 대표가 정면을 보고 서 있고 왼쪽에는 큰 문구를 배치할 수 있는 모바일 HOME 히어로 이미지",
    caption: "WonJYou 스타일 HOME 히어로를 위해 제공된 모바일 전용 MOTIONA 대표 이미지입니다.",
  },
  heroCenterSceneMobile: {
    src: `${imageBase}/hero-center-scene-mobile-v2.webp`,
    alt: "센터 안에서 얼굴 없이 재활운동을 지도하는 모바일 히어로 장면",
    caption: "모바일 첫 화면을 위한 센터 중심 파생 히어로 이미지입니다.",
  },
  heroServicesProgramScene: {
    src: `${imageBase}/services-center-program-banner-v1.webp`,
    alt: "센터 재활운동 공간에서 얼굴이 보이지 않는 구도로 하지 정렬과 움직임을 확인하는 서비스 안내 장면",
    caption: "상태별 재활운동 프로그램을 센터 평가 장면으로 보여주는 파생 이미지입니다.",
  },
  centerIntroSpace: {
    src: `${imageBase}/center-intro-space.webp`,
    alt: "예약제로 운영되는 MOTIONA 재활운동센터 내부 공간",
    caption: "센터 재활운동 소개 섹션을 위한 MOTIONA 실제 공간 이미지입니다.",
  },
  heroConsultationEvaluationScene: {
    src: `${imageBase}/consultation-evaluation-banner-v1.webp`,
    alt: "센터에서 얼굴이 보이지 않는 구도로 하지와 발목 움직임을 평가하는 상담 예약 장면",
    caption: "평가부터 시작하는 상담 흐름을 보여주는 센터 중심 파생 이미지입니다.",
  },
  beforeAfter: {
    src: `${imageBase}/01-before-after.webp`,
    alt: "전신 정렬 변화를 전후로 비교하는 대표 예시",
    caption: "전신 정렬 변화를 전후로 비교하여 현재 몸 상태의 변화를 확인합니다.",
  },
  assistedDumbbell: {
    src: `${imageBase}/core-stability-center-card-v2.webp`,
    alt: "센터에서 얼굴이 보이지 않는 구도로 몸통 안정성 운동을 지도하는 장면",
    caption: "센터에서 필요한 움직임을 보조하며 일상 기능운동으로 연결합니다.",
  },
  shoulderMobility: {
    src: `${imageBase}/core-stability-center-card-v2.webp`,
    alt: "센터에서 얼굴이 보이지 않는 구도로 어깨와 몸통 조절을 지도하는 장면",
    caption: "목, 어깨, 흉추, 고관절의 필요한 움직임을 단계적으로 확인합니다.",
  },
  firstEvaluation: {
    src: `${imageBase}/consultation-evaluation-banner-v1.webp`,
    alt: "센터에서 얼굴이 보이지 않는 구도로 하지와 발목 움직임을 확인하는 첫 평가 장면",
    caption: "하지와 발목 움직임을 확인하며 첫 운동 방향을 정합니다.",
  },
  sidePosture: {
    src: `${imageBase}/07-08-side-posture.webp`,
    alt: "어깨 통증과 측면 자세 정렬 변화를 보여주는 전후 비교 사례",
    caption:
      "날갯죽지 부위 통증과 어깨 말림을 확인하고,\n재활운동 후 어깨 움직임과 측면 자세 변화를 함께 살펴봅니다.",
  },
  neuroWeightShift: {
    src: `${imageBase}/11-neuro-weight-shift.webp`,
    alt: "센터에서 얼굴이 보이지 않는 구도로 체중지지와 몸통 조절을 연습하는 장면",
    caption: "체중지지와 몸통 조절을 바탕으로 보행 준비를 연습합니다.",
  },
  homeSittingBalance: {
    src: `${imageBase}/13-home-sitting-balance.webp`,
    alt: "앉은 자세에서 하지 움직임과 균형 반응을 평가하는 장면",
    caption: "앉은 자세에서 하지 움직임과 균형 반응을 평가합니다.",
  },
  homeWalker: {
    src: `${imageBase}/14-home-walker.webp`,
    alt: "방문 재활에서 얼굴이 보이지 않는 구도로 워커를 이용해 기립과 보행 준비를 연습하는 장면",
    caption: "워커를 이용한 기립과 보행 준비를 연습합니다.",
  },
  wheelchairStand: {
    src: `${imageBase}/15-wheelchair-stand.webp`,
    alt: "휠체어 주변에서 일어서기와 체중지지를 훈련하는 장면",
    caption: "휠체어 주변에서 일어서기와 체중지지를 훈련합니다.",
  },
  birdDog: {
    src: `${imageBase}/core-stability-center-card-v2.webp`,
    alt: "센터에서 얼굴이 보이지 않는 구도로 허리와 골반 안정성을 연습하는 장면",
    caption: "허리와 골반이 흔들리지 않도록 몸통 안정성을 연습합니다.",
  },
  sidePlank: {
    src: `${imageBase}/core-stability-center-card-v2.webp`,
    alt: "센터에서 얼굴이 보이지 않는 구도로 측면 지지와 어깨 안정성을 조절하는 장면",
    caption: "측면 지지와 어깨 안정성을 함께 조절합니다.",
  },
  singleBridge: {
    src: `${imageBase}/core-stability-center-card-v2.webp`,
    alt: "센터에서 얼굴이 보이지 않는 구도로 고관절과 몸통 안정성을 연습하는 장면",
    caption: "고관절 뒤쪽 근육을 사용해 허리 부담을 줄이는 방향으로 운동합니다.",
  },
  neckShoulder: {
    src: `${imageBase}/19-neck-shoulder.webp`,
    alt: "좌식에서 목과 어깨 움직임을 조절하는 장면",
    caption: "목과 어깨의 긴장을 낮추고 자세 인식을 회복합니다.",
  },
  homeShoulder: {
    src: `${imageBase}/home-shoulder-mobility-card-v2.webp`,
    alt: "방문재활 환경에서 얼굴이 보이지 않는 구도로 어깨와 몸통 움직임을 지도하는 장면",
    caption: "가정 환경에 맞춰 어깨와 몸통 움직임을 지도합니다.",
  },
  movementEvaluation: {
    src: `${imageBase}/services-center-program-banner-v1.webp`,
    alt: "센터에서 얼굴이 보이지 않는 구도로 자세와 움직임을 확인하고 운동 방향을 정하는 평가 장면",
    caption: "자세와 움직임을 확인하고 운동 방향을 정합니다.",
  },
  processEvaluation: {
    src: `${imageBase}/process-01-evaluation.webp`,
    alt: "발목과 하지 움직임을 확인하며 현재 몸 상태를 평가하는 장면",
    caption: "현재 움직임과 균형 반응을 먼저 평가합니다.",
  },
  processPlan: {
    src: `${imageBase}/process-02-plan.webp`,
    alt: "하지 움직임과 체중지지를 확인하며 운동 순서를 계획하는 장면",
    caption: "평가 결과를 바탕으로 필요한 운동 순서를 계획합니다.",
  },
  processExercise: {
    src: `${imageBase}/process-03-exercise.webp`,
    alt: "보행과 몸통 조절을 1대1로 연습하는 재활운동 장면",
    caption: "필요한 동작을 1대1로 연습합니다.",
  },
  processCheck: {
    src: `${imageBase}/process-04-check.webp`,
    alt: "상지 움직임을 확인하며 운동 후 변화를 점검하는 장면",
    caption: "운동 후 반응을 확인하고 다음 단계를 조정합니다.",
  },
  shoulderEvaluation: {
    src: `${imageBase}/22-shoulder-evaluation.webp`,
    alt: "어깨와 상지 움직임을 확인하며 필요한 조절을 지도하는 장면",
    caption: "어깨와 상지 움직임을 확인하며 필요한 조절을 지도합니다.",
  },
  scapulaExample: {
    src: `${imageBase}/23-scapula-example.webp`,
    alt: "어깨와 견갑의 하강 조절을 연습한 전후 예시",
    caption: "어깨와 견갑의 하강 조절을 연습해 상체 움직임을 정리합니다.",
  },
  neuroPelvisLeg: {
    src: `${imageBase}/11-neuro-weight-shift.webp`,
    alt: "센터에서 얼굴이 보이지 않는 구도로 고관절과 골반 조절을 연습하는 장면",
    caption:
      "상지 움직임 중 어깨 안정성을 유지하며 고관절과 골반의 대각선 패턴으로 하지의 선택적 조절을 연습합니다.",
  },
} satisfies Record<string, MotionaImage>;

export const serviceHeroSlides = [
  {
    title: "지금 몸 상태에서 시작합니다",
    image: {
      src: `${imageBase}/services-hero-01-profile-clean.webp`,
      alt: "MOTIONA 대표가 따뜻한 배경 앞에 서 있는 센터 소개 히어로 이미지",
      caption: "대표 프로필 장면으로 센터 소개 첫 화면의 신뢰감을 만듭니다.",
    },
    desktopPosition: "center center",
    mobilePosition: "65% center",
  },
  {
    title: "걸음의 기준을 다시 봅니다",
    image: {
      src: `${imageBase}/services-hero-02-gait-clean.webp`,
      alt: "계단에서 보행 움직임을 확인하는 재활운동 히어로 이미지",
      caption: "계단 보행 장면으로 보행과 균형의 기준을 보여줍니다.",
    },
    desktopPosition: "center center",
    mobilePosition: "68% center",
  },
  {
    title: "균형과 체중지지를 다시 맞춥니다",
    image: {
      src: `${imageBase}/services-hero-03-neuro-clean.webp`,
      alt: "센터에서 체중지지와 몸통 조절을 확인하는 재활운동 히어로 이미지",
      caption: "센터 내 신경계 기능회복 장면으로 체중지지와 조절을 보여줍니다.",
    },
    desktopPosition: "center center",
    mobilePosition: "68% center",
  },
  {
    title: "통증 너머의 움직임을 봅니다",
    image: {
      src: `${imageBase}/services-hero-04-knee-clean.webp`,
      alt: "무릎과 하지 움직임을 확인하는 근골격계 재활운동 히어로 이미지",
      caption: "무릎 수술 후 움직임 평가 장면으로 안전한 재활운동 방향을 보여줍니다.",
    },
    desktopPosition: "center center",
    mobilePosition: "64% center",
  },
  {
    title: "집에서도 흐름을 이어갑니다",
    image: {
      src: `${imageBase}/services-hero-05-home-clean.webp`,
      alt: "방문재활 환경에서 워커를 이용해 기립과 보행 준비를 연습하는 히어로 이미지",
      caption: "방문재활 장면으로 생활공간에서 이어지는 재활운동을 보여줍니다.",
    },
    desktopPosition: "center center",
    mobilePosition: "66% center",
  },
] satisfies readonly ServiceHeroSlide[];

export const serviceCards = [
  {
    title: "신경계 기능회복",
    copy: "보행과 균형이 불안할 때 몸통 조절과 체중지지부터 다시 연습합니다.",
    image: images.neuroWeightShift,
    href: ctaLinks.naverBooking,
    actionLabel: "센터 예약하기",
  },
  {
    title: "근골격계 통증·기능개선",
    copy: "허리와 어깨와 무릎의 반복되는 불편감을 움직임의 습관까지 함께 봅니다.",
    image: images.birdDog,
    href: ctaLinks.naverBooking,
    actionLabel: "센터 예약하기",
  },
  {
    title: "수술 전후 회복 운동",
    copy: "수술 전후에 무리하지 않고 일상으로 돌아갈 수 있도록 운동 순서를 잡습니다.",
    image: images.firstEvaluation,
    href: ctaLinks.naverBooking,
    actionLabel: "센터 예약하기",
  },
  {
    title: "방문 재활운동",
    copy: "센터 방문이 어렵다면 집에서 일어서기와 걷기와 생활 동작을 이어갑니다.",
    image: images.homeWalker,
    href: ctaLinks.visitSms,
    actionLabel: "문자 문의하기",
  },
];

export const homeFaqs = [
  {
    question: "모티오나는 어떤 의미를 담고 있나요?",
    answer: [
      "모티오나 MOTIONA는 움직임을 뜻하는 Motion과 정렬을 뜻하는 Alignment의 의미를 담고 있습니다.",
      "흐트러진 움직임을 다시 정리하고, 몸이 안정된 방향으로 회복될 수 있도록 돕겠다는 뜻을 담았습니다.",
    ],
  },
  {
    question: "모티오나 재활운동센터는 어떤 곳인가요?",
    answer: [
      "모티오나는 병원 이후 운동이 필요한 분을 위한 1:1 재활운동센터입니다.",
      "물리치료사 경력의 전문가가 몸 상태와 움직임을 보고 센터 재활운동이나 방문재활운동으로 이어갑니다.",
    ],
  },
  {
    question: "다른 센터들과 모티오나의 가장 큰 차이는 무엇인가요?",
    answer: [
      "모티오나는 아픈 부위만 따로 보지 않습니다.",
      "왜 그 부위에 부담이 가는지 자세와 보행과 균형까지 함께 봅니다. 그래서 운동도 사람마다 다르게 시작합니다.",
    ],
  },
  {
    question: "왜 모티오나를 시작하게 되었나요?",
    answer: [
      "12년간 병원에서 일하며 퇴원 뒤 갑자기 막막해지는 순간을 자주 봤습니다.",
      "도움이 필요한 몸인데도 어디서 운동을 이어가야 할지 모르는 분들이 많았습니다. 병원 밖에서도 몸을 이해하고 다시 움직일 수 있도록 돕고 싶어 모티오나를 시작했습니다.",
    ],
  },
  {
    question: "모티오나가 추구하는 재활운동 철학은 무엇인가요?",
    answer: [
      "몸을 대신 고쳐주는 시간이 아니라 다시 움직이는 법을 배우는 시간에 가깝습니다.",
      "통증을 줄이는 것에서 멈추지 않고 내 몸을 이해하고 일상에서 스스로 조절할 수 있는 힘을 기르는 것을 목표로 합니다.",
    ],
  },
  {
    question: "몸이 아파도 운동할 수 있을까요?",
    answer: [
      "쉬어야 하는 통증도 있고 움직여야 풀리는 불편감도 있습니다.",
      "첫 평가는 그 차이를 구분하기 위한 시간입니다. 통증의 반응과 피로와 경직 상태를 보고 지금 필요한 운동을 정합니다.",
    ],
  },
  {
    question: "어떤 분들이 오시면 좋을까요?",
    answer: [
      "뇌졸중·파킨슨·척수손상 이후 보행과 균형이 불안한 분께 도움이 됩니다.",
      "수술 전후 기능 회복이 필요하거나 허리·어깨·무릎 통증과 자세 문제로 일상이 불편한 분도 함께 볼 수 있습니다.",
    ],
  },
  {
    question: "어떤 수업을 하나요?",
    answer: [
      "센터에서는 재활운동과 기능회복운동을 중심으로 보행훈련과 균형훈련을 진행합니다.",
      "근력운동과 필라테스 기반 운동도 몸 상태에 맞춰 구성합니다. 센터 방문이 어렵다면 방문재활운동으로 이어갈 수 있습니다.",
    ],
  },
  {
    question: "수업은 어떻게 진행되나요?",
    answer: [
      "첫 수업은 상담과 평가에서 시작합니다. 어디가 불편한지뿐 아니라 어떤 움직임이 어려운지 함께 봅니다.",
      "자세와 균형과 관절 움직임과 보행을 확인한 뒤 목표를 정합니다. 이후 몸의 반응에 맞춰 운동을 조정합니다.",
    ],
  },
  {
    question: "모티오나는 의료기관인가요?",
    answer: [
      "모티오나는 의료기관이 아닌 기능회복 재활운동센터입니다.",
      "의학적 진단이나 의료행위를 대신하지 않습니다. 병원에서의 임상 경험을 바탕으로 몸 상태와 움직임을 살피고 일상 회복에 필요한 운동 방향을 안내합니다.",
      "의료적 판단이 필요한 증상은 병원 진료를 먼저 권합니다.",
    ],
  },
  {
    question: "1:1 수업만 가능한가요?",
    answer: [
      "현재 모티오나는 프라이빗 1:1 전문센터로 운영됩니다.",
      "한 분의 몸을 깊이 있게 살피고 상태에 맞는 운동을 적용하기 위해 예약제 1:1 수업을 중심으로 진행합니다.",
    ],
  },
  {
    question: "방문재활운동도 가능한가요?",
    answer: [
      "네 가능합니다. 센터 방문이 어렵거나 집에서 생활 동작을 바로 연습해야 하는 분을 위해 방문재활운동을 진행합니다.",
      "서울·경기북부를 중심으로 안내드리며 다른 지역은 상담 후 가능 여부를 확인해드립니다.",
    ],
  },
  {
    question: "위치와 주차는 어떻게 되나요?",
    answer: [
      "센터 앞 주차가 가능합니다. 수유역에서 걸어서 약 10분 거리입니다. 수유역 6번 출구 앞에서 도봉 2·3·4 마을버스를 타고 쌍문교에서 내리시면 됩니다.",
      "자세한 위치 안내는 예약 시 도와드립니다.",
    ],
  },
  {
    question: "처음 방문하는 분들에게 하고 싶은 말은 무엇인가요?",
    answer: [
      "몸이 예전 같지 않으면 움직이는 것 자체가 조심스러워집니다.",
      "그래도 회복은 내 몸을 피하는 데서 시작되지 않습니다. 지금 가능한 움직임을 함께 찾고 일상으로 돌아가는 길을 차분히 이어가겠습니다.",
    ],
  },
] as const;

export const routeSummaries = {
  home: {
    title: "HOME",
    copy: "병원 이후 일상 회복을 MOTIONA에서 어떻게 이어갈지, 센터의 기준과 흐름까지 함께 확인합니다.",
  },
  services: {
    title: "센터 소개",
    copy: "몸 상태를 평가하고 센터 재활운동, 방문재활, 상담 흐름까지 한 페이지에서 살펴봅니다.",
  },
  centerPhotos: {
    title: "센터 사진",
    copy: "센터 공간과 1:1 재활운동 자료 사진을 한 페이지에서 확인합니다.",
  },
} satisfies Record<NavKey, { title: string; copy: string }>;

export const processSteps = [
  {
    step: "01",
    title: "평가",
    copy: "자세와 관절 움직임과 보행 패턴을 먼저 확인합니다.",
    image: images.firstEvaluation,
  },
  {
    step: "02",
    title: "계획",
    copy: "통증 반응과 보상 움직임을 구분해 운동 순서를 정합니다.",
    image: images.shoulderMobility,
  },
  {
    step: "03",
    title: "운동",
    copy: "가동성과 안정성과 체중지지를 기능운동으로 연결합니다.",
    image: images.sidePlank,
  },
  {
    step: "04",
    title: "변화 확인",
    copy: "자세와 움직임 변화를 확인하며 일상 동작으로 이어갑니다.",
    image: images.assistedDumbbell,
  },
];
